

export const localization = {
    ru: {
        menuSectionText: {
            localeBadge: 'EN'
        },
        aboutSectionText: {
            aboutSectionTitle0: 'Станкин в ',
            aboutSectionTitle1: 'ТВОИХ',
            aboutSectionTitle2: ' руках',
            appDescriptionTitle: 'Вся информация о ТВОЁМ университете',
            appDescriptionText: 'Соберите всю информацию о своём университете в смартфоне. Сделайте своё обучение удобнее и тратье больше времени на получение настоящих знаний.',

        },
        featureSectionText: {
            featureSectionTitle0: 'Теперь ты можешь ',
            featureSectionTitle1: 'ВСЁ',
            scheduleSlideText: 'Знать расписание на любой день, название предмета, время и место занятия.',
            modulesSlideText: 'Получать полную информацию о модулях за всё время обучения. Оценки за модули, зачёты, экзамены.',
            newsSlideText: 'Быть в курсе последних новостей университета и деканата. Читать о них коротко или подробно.',
            infoSlideText: 'Иметь под рукой самую важную информацию об университете.',
        },
        soonSectionText: {
            soonSectionTitle0: 'Скоро ',
            soonSectionTitle1: 'ЕЩЁ',
            soonSectionTitle2: ' больше',
            notificationText: 'Уведомления о парах, оценках, новостях',
            infoText: 'Расширенная информация о ВУЗе, кафедрах, преподавателях',
            scheduleText: 'Автообновление расписания',
            offlineText: 'Работа приложения offline и синхронизация'
        },
        authorsSectionText: {
            authorsSectionTitle0: 'Делают ',
            authorsSectionTitle1: 'ВСЁ',
            authorsSectionTitle2: ' возможное',
            matericin: 'Василий Материкин',
            muslimov: 'Данияр Муслимов',
            kirsakova: 'Ксения Кирсакова',
            ermakov: 'Александр Ермаков',
            balagansky: 'Алексей Балаганский',
            kolyachenko: 'Максим Коляченко',
            nikonorov: 'Даниил Никоноров',
            teamLead: 'руководитель',
            scrumMaster: 'scrum-master',
            analyst: 'аналитик',
            designer: 'дизайнер',
            programmer: 'программист',
        }
    },
    en: {
        menuSectionText: {
            localeBadge: 'RU'
        },
        aboutSectionText: {
            aboutSectionTitle0: 'Stankin in ',
            aboutSectionTitle1: 'YOUR',
            aboutSectionTitle2: ' smartphone',
            appDescriptionTitle: 'All information about YOUR University',
            appDescriptionText: 'Gather all the information about your university in your smartphone. Make your learning easier and spend more time getting real knowledge',

        },
        featureSectionText: {
            featureSectionTitle0: 'Now you can do ',
            featureSectionTitle1: 'EVERYTHING',
            scheduleSlideText: 'Know the schedule for any day, the name of the subject, the time and place of the lesson.',
            modulesSlideText: 'Get full information about the modules for the entire training period. Grades for modules, tests, exams.',
            newsSlideText: 'Keep abreast of the latest university news and dean\'s office. Read about them briefly or in detail.',
            infoSlideText: 'Have the most important information about the university nearby.',
        },
        soonSectionText: {
            soonSectionTitle0: 'Coming',
            soonSectionTitle1: 'SOON',
            soonSectionTitle2: '',
            notificationText: 'Couples, Ratings, News Notifications',
            infoText: 'Extended information about the university, departments, teachers',
            scheduleText: 'Auto Update Schedule',
            offlineText: 'Application offline work and synchronization'
        },
        authorsSectionText: {
            authorsSectionTitle0: '',
            authorsSectionTitle1: 'THEY ',
            authorsSectionTitle2: ' do their best',
            matericin: 'Vasily Materikin',
            muslimov: 'Daniyar Muslimov',
            kirsakova: 'Ksenia Kirsakova',
            ermakov: 'Alexander Ermakov',
            balagansky: 'Alexey Balagansky',
            kolyachenko: 'Maxim Kolyachenko',
            nikonorov: 'Daniil Nikonorov',
            teamLead: 'teamlead',
            scrumMaster: 'scrum-master',
            analyst: 'analyst',
            designer: 'designer',
            programmer: 'programmer',
        }
    }
}
